import { createContext, useContext } from "react"
import { WEBSITE_BUILDER_TYPES } from "modules/website-builder/constants/websiteTypes"

export const WebsiteBuilderTenantContext = createContext(null)

export const useWebsiteBuilderTenantId = () => {
  const ctx = useContext(WebsiteBuilderTenantContext)
  return ctx?.tenantId || null
}

export const useWebsiteBuilderType = () => {
  const ctx = useContext(WebsiteBuilderTenantContext)
  return ctx?.websiteType || WEBSITE_BUILDER_TYPES.STOREFRONT
}
